import { useMemo } from 'react';
import { useShellLayout } from './useShellLayout';

export interface ResponsivePopupOptions {
  width?: number | string;
  height?: number | string;
  fullScreen?: boolean;
}

/**
 * Applies fullScreen on narrow viewports so popups fit phones/tablets.
 * Returns a memoized options object — DevExtreme Popup must not receive a new
 * options identity every render (React 19 + DX template updates → error #185).
 */
export function useResponsivePopupOptions(
  base: ResponsivePopupOptions
): ResponsivePopupOptions {
  const { isNarrow } = useShellLayout();
  const width = base.width;
  const height = base.height;
  const fullScreen = base.fullScreen;

  return useMemo(() => {
    if (isNarrow) {
      return { fullScreen: true };
    }
    return { width, height, fullScreen };
  }, [isNarrow, width, height, fullScreen]);
}
